import { COUPONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'

const update_coupon_request = () => {
  return {
    type: couponsTypes.update.request
  }
}

const update_coupon_success = (response) => {
  return {
    type: couponsTypes.update.success,
    payload: response.data.coupon
  }
}

const update_coupon_failure = (messages) => {
  return {
    type: couponsTypes.update.failure,
    payload: messages
  }
}

const update_coupon = (coupon_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_coupon_request())

    // Request
    axios.patch(
      formatRoute(COUPONS_ROUTES.update, {id: coupon_id}),
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "Coupon data has been updated")
      dispatch( update_coupon_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating coupon."]
      }
      window.showSnackbar('error', errors)
      dispatch( update_coupon_failure(errors))
    })
  }

}

export {
  update_coupon
}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/update.js